import { render, staticRenderFns } from "./Carry.vue?vue&type=template&id=6df06e66&scoped=true"
import script from "./Carry.vue?vue&type=script&lang=js"
export * from "./Carry.vue?vue&type=script&lang=js"
import style0 from "./Carry.vue?vue&type=style&index=0&id=6df06e66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df06e66",
  null
  
)

export default component.exports